<template>
  <div class="w-100">
    <label>Período</label>
    <div class="input-group">
      <input class="form-control" type="date">
      <span class="input-group-append">
        <span class="input-group-text">Até</span>
      </span>
      <input class="form-control" type="date">
    </div>
  </div>
</template>

<script>
export default {

}
</script>
